import axiosClient from './axiosClient'

const miscApi = {
  findByLookupCode: (lookupCode) => {
    const url = `/misc/find-by-lookup-code?lookupCode=${lookupCode}`
    return axiosClient.get(url)
  },

  exportLookupCode: (lookupCode) => {
    const url = `/misc/export-by-lookup-code?lookupCode=${lookupCode}`

    return axiosClient.get(url, { params: { typeWebsite: 1 } })
  },
}

export default miscApi
